import { useTranslation } from 'react-i18next'

import { type IPlaylist } from 'types/interfaces/ITypes'

import styles from './mediaItemPlaylist.module.scss'

interface Props {
  playlistData: IPlaylist
  active: boolean
  setIsActive: () => void
  customClass?: string
  data?: any
}

export const MediaItemPlaylist = ({
  playlistData,
  active,
  setIsActive,
  customClass,
}: Props) => {
  const { t } = useTranslation()

  const posts = playlistData?.last_four_posts || []

  const thumbs = posts.flatMap((p: any) => {
    const photos =
      p.photos?.map(
        (ph: any) =>
          ph.thumb_url ||
          ph.url ||
          ph.src
      ) || []

    const videos =
  p.videos?.map((v: any) => v.active_thumb) ?? []

    return [
      ...photos,
      ...videos,
    ].filter(Boolean)
  })

const playlistName =
  playlistData?.playlist_info?.name ?? ''

  const postCount =
    posts.length ||
    (
      (playlistData?.media_counters?.photo_sum ?? 0) +
      (playlistData?.media_counters?.video_sum ?? 0) +
      (playlistData?.media_counters?.sound_sum ?? 0)
    )

  const isEmpty =
    !playlistData?.media_counters?.photo_sum &&
    !playlistData?.media_counters?.video_sum &&
    !playlistData?.media_counters?.sound_sum

  const mainThumb = thumbs[0]
  const secondThumb = thumbs[1] ?? mainThumb
  const thirdThumb = thumbs[2] ?? secondThumb ?? mainThumb

  return (
    <div
      onClick={setIsActive}
      className={`
        ${styles.wrapper}
        ${customClass ?? ''}
      `}
    >
      <div
        className={`
          ${styles.media}
          ${active ? styles.active : ''}
        `}
      >
        {thumbs.length > 0 ? (
          <>
            <div className={styles.previewGrid}>
              <div className={styles.mainPreview}>
                <img
                  src={mainThumb}
                  alt=''
                  className={styles.img}
                />
              </div>

              <div className={styles.sidePreviews}>
                <div className={styles.sidePreview}>
                  <img
                    src={secondThumb}
                    alt=''
                    className={styles.img}
                  />
                </div>

                <div className={styles.sidePreview}>
                  <img
                    src={thirdThumb}
                    alt=''
                    className={styles.img}
                  />
                </div>
              </div>
            </div>

            <div className={styles.bottomGradient} />

            <div className={styles.playlistInfo}>
              <div className={styles.playlistName}>
                {playlistName}
              </div>

              <div className={styles.postCount}>
                {postCount}{' '}
                {postCount === 1 ? 'post' : 'posts'}
              </div>
            </div>

            <div className={styles.arrowButton}>
            <svg
              width="11"
              height="17"
              viewBox="0 0 16 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5 4L11 12L5 20"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </div>
          </>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyInner}>
              <div className={styles.playlistNameEmpty}>
                {playlistName}
              </div>

              {isEmpty && (
                <div className={styles.subtitle}>
                  {t('thisPlaylistIsEmpty')}
                </div>
              )}
            </div>

            <div className={styles.arrowButton}>
            <svg
              width="11"
              height="17"
              viewBox="0 0 16 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5 4L11 12L5 20"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}